define('ordersDetailBodyView',[
  'app',
  'module',
  'underscore',
  'settings',
  'rolesMixin',
  'tabsViewView',
  'horizontalCollapseView',
  'customerInternalCommentsView',
  'ordersDetailOrderView',
  'ordersDetailPriceV2View',
  'ordersDetailPriceMain',
  'orderdDetailCompositionView',
  'ordersDetailAttachmentsView',
  'ordersDetailDocumentsView',
  'ordersDetailTrackingListView',
  'customersDetailBodyCallsView',
  'ordersDetailMailsView',
  'ordersDetailMessagesView',
  'ordersDetailAiChatView',
  'ordersDetailInvoicesView',
  'ordersDetailMollieView',
  'ordersDetailSupplierView'
], function (
  App,
  Module,
  _,
  Settings,
  RolesMixin,
  TabsView,
  HorizontalCollapseView,
  CustomerInternalCommentsView
) {
  'use strict';

  Module.exports = TabsView.extend({
    selectedTab: 'details',
    className: 'orders-detail-body-view ' + TabsView.prototype.className,

    initialize: function () {
      TabsView.prototype.initialize.apply(this, arguments);

      this.selectedTab = this.options.tabName || 'details';
    },

    tabs: function () {
      var items = [];

      var test = false;
      if (Settings.configValue('test.showAllTabs') === true)
        test = true;

      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DETAIL] || test) {
        items.push({
          name: 'details',
          url: '',
          title: _.i18n('orders.details.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_DETAIL,
          defaultSelected: true,
          view: 'ordersDetailOrderView'
        });
      }     

      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_PRICE] || test) {
        items.push({
          name: 'pricev2',
          url: 'pricev2',
          title: _.i18n('orders.pricev2.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_PRICE,
          view: 'ordersDetailPriceV2View',
          alwaysReload: true
        });
      }

      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_PRICE_OLD] || test) {
        items.push({
          name: 'price',
          url: 'price',
          title: _.i18n('orders.price.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_PRICE_OLD,
          view: 'ordersDetailPriceMain',
          alwaysReload: true
        });
      }

      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_PERSONALIZATION] || test) {
        items.push({
          name: 'composition',
          url: 'composition',
          title: _.i18n('orders.composition.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_PERSONALIZATION,
          view: 'orderdDetailCompositionView'
        });
      }

      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_ATTACHMENT] || test) {
        items.push({
          name: 'attachments',
          url: 'attachments',
          title: _.i18n('orders.attachments.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_ATTACHMENT,
          view: 'ordersDetailAttachmentsView'
        });
      }
      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DOCUMENTS] || test) {
        items.push({
          name: 'documents',
          url: 'documents',
          title: _.i18n('documents.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_DOCUMENTS,
          view: 'ordersDetailDocumentsView'
        });
      }
      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_TRACKING] || test) {
        items.push({
          name: 'tracking',
          url: 'tracking',
          title: _.i18n('orders.tracking.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_TRACKING,
          view: 'ordersDetailTrackingListView'
        });
      }
      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_CALLS] || test) {
        items.push({
          name: 'calls',
          url: 'calls',
          title: _.i18n('endUsersDetail.calls.tabTitle'),
          role: RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_CALLS,
          view: 'customersDetailBodyCallsView'
        });
      }
      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_MAILS] || test) {
        items.push({
          name: 'mails',
          url: 'mails',
          title: _.i18n('menu.mails'),
          role: RolesMixin.DASHBOARD_ORDERS_MAILS,
          view: 'ordersDetailMailsView'
        });
      }
      if((Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_AI_ASSISTANT] &&
          Settings.get('aiAssistantUser') === true) || test) {
        items.push({
          name: 'ai_assistant',
          url: 'ai_assistant',
          title: _.i18n('orders.aiAssistant.tabTitle', null, 'AI Assistant'),
          role: RolesMixin.DASHBOARD_ORDERS_AI_ASSISTANT,
          view: 'ordersDetailAiChatView'
        });
      }
      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_INTERNAL_MESSAGES] || test) {
        items.push({
          name: 'internal_messages',
          url: 'internal_messages',
          title: _.i18n('tab.messagesCs'),
          role: RolesMixin.DASHBOARD_ORDERS_INTERNAL_MESSAGES,
          view: 'ordersDetailMessagesView'
        });
      }
      if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_INVOICES] || test) {
        items.push({
          name: 'invoices',
          url: 'invoices',
          title: _.i18n('cAccountDetail.invoices.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_INVOICES,
          view: 'ordersDetailInvoicesView'
        });
      }

      if (Settings.configValue('advancedMode') === true) {
        if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_MOLLIE] || test) {
          items.push({
            name: 'mollie',
            url: 'mollie',
            title: _.i18n('cAccountDetail.mollie.tabTitle'),
            role: RolesMixin.DASHBOARD_ORDERS_MOLLIE,
            view: 'ordersDetailMollieView'
          });
        }
      }

      /*if(Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_PROOFSHEET_HISTORY] || test) {
        items.push({
          name: 'order_proofsheet_history',
          url: 'order_proofsheet_history',
          title: _.i18n('cAccountDetail.proofsheetHistory.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_PROOFSHEET_HISTORY,
          view: 'orderProofsheetHistoryTabController'
        });
      }*/

      var cAccountConfig = Settings.get('cAccountConfig');
      if((Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_TO_SUPPLIER] || test) && cAccountConfig &&
          cAccountConfig.get('supplierWSConfigs') && _.findWhere(cAccountConfig.get('supplierWSConfigs'),
          { supplierCode: this.model.get('order').get('productOwner')})) {
        items.push({
          name: 'order_supplier',
          url: 'order_supplier',
          title: _.i18n('cAccountDetail.orderSupplier.tabTitle'),
          role: RolesMixin.DASHBOARD_ORDERS_TO_SUPPLIER,
          view: 'ordersDetailSupplierView',
          alwaysReload: true
        });
      }

      return items;
    },

    getChildView: function () {
      return HorizontalCollapseView.extend({
        childRightView: CustomerInternalCommentsView.extend({opened: true})
      });
    },
  
    loading: function(value) {
      if(value)
        this.ui.loading.addClass('activated');
      else
        this.ui.loading.removeClass('activated');
    }
  });
});

